import { render, staticRenderFns } from "./CardPrice.vue?vue&type=template&id=1cb307ec&scoped=true"
import script from "./CardPrice.vue?vue&type=script&lang=js"
export * from "./CardPrice.vue?vue&type=script&lang=js"
import style0 from "./CardPrice.vue?vue&type=style&index=0&id=1cb307ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb307ec",
  null
  
)

export default component.exports